import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ContentSidebar from './Content_sidebar';
import Article from './Article';
import NavArticle from './Article_nav';
import ApiSidebar from './Api_sidebar';
import { useTranslation } from 'react-i18next';
import Meta from "../../components/dynamicMeta"
import { useLogin } from '../../components/logIncontext';

const ContentInterface = () => {
  const { lang, category, subcategory, nestedSubcategory, article } = useParams();
  const isApiCategory = category === 'api';
  const formulasSlugs = ['formulas', 'formules', 'formule', 'formulas-zh'];
  const isFormulasCategory = formulasSlugs.includes(category);
  const { t, i18n } = useTranslation();
  const { userData } = useLogin();

  // Proteger rutas de API y Formulas
  if (isApiCategory || isFormulasCategory) {
    const isLocalhost = window.location.hostname === 'localhost';
    const apiEnabled = userData?.config?.apiEnabled;
    const formulasEnabled = userData?.config?.formulasEnabled;
    
    if (isApiCategory && !isLocalhost && !apiEnabled) {
      return <Navigate to={`/${lang}/`} replace />;
    }
    if (isFormulasCategory && !isLocalhost && !formulasEnabled) {
      return <Navigate to={`/${lang}/`} replace />;
    }
  }

  // Cambiar el idioma según la URL
  React.useEffect(() => {
    if (lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <div>
      <Meta/>
          <div className={`pt-[7rem] sm:pt[7rem] md:pt-[9rem] lg:pt-[9rem] xl:pt-[9rem] 2xl:pt-[9rem] grid grid-cols-1 ${isApiCategory || isFormulasCategory ? 'lg:grid-cols-4' : 'lg:grid-cols-8'} gap-4 px-4 sm:px-28 md:px-16 py-4 sm:py-10 dark:bg-bgPrimary dark:text-gray-200`}>
      
      {isApiCategory || isFormulasCategory ? (
        // Layout para API & Formulas: 1/4 navegación + 3/4 artículo
        <>
          {/* Navegación API & Formulas - 1/4 */}
          <div className="lg:col-span-1 border-b lg:border-b-0 lg:border-r border-gray-300 dark:border-gray-700 pb-4 lg:pb-0 lg:pr-4">
            <ApiSidebar />
          </div>
          
          {/* Artículo API & Formulas - 3/4 */}
          <div className="lg:col-span-3 px-0 sm:px-4">
            {article ? (
              <Article category={category} article={article} />
            ) : (
              <p className="text-lg text-gray-500 dark:text-gray-400">{t('selectArticleMessage')}</p>
            )}
          </div>
        </>
      ) : (
        // Layout normal para otras categorías
        <>
          {/* Sidebar */}
          <div className="hidden lg:block lg:col-span-2 border-b lg:border-b-0 lg:border-r border-gray-300 dark:border-gray-700 pb-4 lg:pb-0 lg:pr-4 order-1 lg:order-1">
            <ContentSidebar currentCategory={category} />
          </div>

          {/* Navigation */}
          <div className="lg:col-span-2 lg:border-l border-gray-300 dark:border-gray-700 lg:pt-0 lg:pl-4 order-2 lg:order-3">
            {article && <NavArticle />}
            <div className="border-t border-gray-300 dark:border-gray-700 mt-4 lg:hidden"></div>
          </div>

          {/* Article */}
          <div className="lg:col-span-4 px-0 sm:px-4 order-3 lg:order-2">
            {article ? (
              <Article category={category} article={article} />
            ) : (
              <p className="text-lg text-gray-500 dark:text-gray-400">{t('selectArticleMessage')}</p>
            )}
          </div>
        </>
      )}
    </div>
    </div>

  );
};

export default ContentInterface;
